/**
 * Flags de compilación para piezas que están EN el código pero no en producción.
 *
 * POR QUÉ NO SON `featureFlags` DE FIRESTORE. Los que hay en el documento del tenant
 * —`embeddedSignupEnabled`, por ejemplo (`src/pages/Canales.jsx:502`)— son kill
 * switches: **encendidos por defecto**, se apagan por excepción. Sirven para retirar
 * algo que ya está desplegado.
 *
 * Esto es lo contrario: **apagado por defecto**, para una pieza cuyo backend **no está
 * desplegado**. Un flag de Firestore no valdría, porque encenderlo desde soporte
 * mostraría un botón que llama a una función que no existe — un 404 en la cara del
 * cliente. Aquí el interruptor es de compilación a propósito: encenderlo exige tocar el
 * código, que es exactamente el momento en que alguien mira si el backend está arriba.
 *
 * Y NO ES `display: none`. Con la constante en `false` el JSX **no se renderiza**: el
 * botón no existe en el DOM, así que no hay nada que un usuario curioso revierta desde
 * las devtools. Sólo cambiar esta línea y reconstruir el bundle lo trae de vuelta.
 */

/**
 * Dentalink (HealthAtom) — vertical dental.
 *
 * El código se fusionó a `main` el 8-sep-2026 (Fase 2) para que la rama dejara de
 * divergir: 545 commits de `main` desde la base del 12-ago, sobre los mismos ficheros
 * que la Fase 3 va a reescribir. Fusionar no es lanzar.
 *
 * ENCENDERLO SON CUATRO SITIOS, Y VAN JUNTOS:
 *   1. esta constante → `true`
 *   2-4. las tres líneas comentadas de `functions/index.js` (`saveDentalinkConfig`,
 *        `dentalinkInbound`, `processDentalinkEventsScheduled`)
 *
 * Encender sólo la UI deja un botón que responde 404. Encender sólo el backend no hace
 * daño, pero tampoco sirve de nada.
 *
 * Lo que sigue bloqueando NO es técnico: falta que Go Smile contrate el plan API con
 * HealthAtom. Ver `LANZAMIENTO-ESTADO.md` → P1-10.
 */
export const DENTALINK_HABILITADO = false;

/**
 * Seguimiento automático de preguntas abiertas — docs/SEGUIMIENTO.md.
 *
 * ENCENDIDO el 20-oct-2026 (decisión de Rodrigo): la tarjeta de configuración y el resumen del
 * mes salen en el panel de integraciones de TODOS los clientes. Un bot sin config sigue con
 * `activado: false` —nadie recibe toques sin activarlo él— y la UI sólo escribe sus 7 campos
 * (no `ordenToques` ni `listaBlanca`, que el `merge` conserva). Para APAGAR: este valor a `false`,
 * `npm run build` y `npm run deploy:app` (docs/OPERACION.md).
 */
export const SEGUIMIENTO_AUTO_HABILITADO = true;
